import React from "react";

const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  if (pageNumbers.length <= 1) return null;

  return (
    <div>
      <div className="btn-group">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => paginate(1)}
          disabled={currentPage === 1}
        >
          First
        </button>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => currentPage > 1 && paginate(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() =>
            currentPage < pageNumbers.length && paginate(currentPage + 1)
          }
          disabled={currentPage === pageNumbers.length}
        >
          Next
        </button>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => paginate(pageNumbers.length)}
          disabled={currentPage === pageNumbers.length}
        >
          Last
        </button>
      </div>
    </div>
  );
};

export default Pagination;
